import React from "react";
import {Spinner} from "react-bootstrap";
import CacheBuster from "react-cache-buster";
import ReactDOM from "react-dom";
import {version} from "../package.json";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorkerRegistration";
import Loading from "./components/Loading";

const isProduction = process.env.NODE_ENV === "production";

ReactDOM.render(
    <CacheBuster
        currentVersion={version}
        isEnabled={isProduction} //If false, the library is disabled.
        isVerboseMode={true} //If true, the library writes verbose logs to console.
        loadingComponent={<Loading/>} //If not pass, nothing appears at the time of new version check.
    >
        <App/>
    </CacheBuster>,
    document.getElementById("root")
);
//
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.register();
reportWebVitals();
